const generateRecipeIndex = recipes => recipes

export default generateRecipeIndex
